import styled from "styled-components";

export const Container = styled.div`
  background: ${(props) => props.theme.common.secondaryColor};
  height: 100%;
  padding: 20px;
  color: ${(props) => props.theme.common.mainHeadingColor};
  font-size: 0.85rem;
`;

export const Description = styled.p`
  margin-bottom: 16px;
  line-height: 1.5;
  color: ${(props) => props.theme.common.subHeadingColor};

  code {
    font-family: inherit;
    background: ${(props) => props.theme.badge.bgColor};
    padding: 0 6px;
    border-radius: 6px;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 0.8rem;
  color: ${(props) => props.theme.common.subHeadingColor};
  margin-bottom: 12px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  margin-top: 6px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.common.borderColor};
  background: ${(props) => props.theme.common.primaryColor};
  color: ${(props) => props.theme.common.mainHeadingColor};
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  margin-top: 6px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.common.borderColor};
  background: ${(props) => props.theme.common.primaryColor};
  color: ${(props) => props.theme.common.mainHeadingColor};
  resize: vertical;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SubmitButton = styled.button`
  background: ${(props) => props.theme.common.tertiaryColor};
  color: white;
  border-radius: 999px;
  padding: 10px 16px;
  font-weight: 600;
  align-self: flex-start;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
`;

export const Status = styled.div<{ isError?: boolean }>`
  min-height: 18px;
  color: ${(props) => (props.isError ? "#c2574a" : props.theme.common.subHeadingColor)};
  font-size: 0.75rem;
`;
